import Loading from "common/fragments/Loading";
import { CardView } from "common/views/card/Card.view";
import { ITab, TabsView } from "common/views/tab/Tabs.view";
import Query from "core/api/QueryComponent";
import { FragmentLayout } from "core/components/FragmentLayout";
import Label from "core/components/label/Label";
import ServiceRegistry from "core/util/ServiceRegistry";
import { iDef } from "core/util/TypeUtils";
import ContainerView from "panels/container/view/Container.view";
import React from "react";
import styled from "styled-components";
import { EnrollmentsComponent } from "./EnrollmentsComponent";
import { Institution, Program } from "./entities/Institution";
import { TestAssignment } from "./entities/TestAssignment";
import * as displayFragments from "./fragments/displayFragments";
import { QuizQuestionsComponent } from "./QuizQuestionsComponent";
import TestAssignmentFormConfig from "./TestAssignmentListConfig";

const StyledDiv = styled.div`
	 {
		& > div > div{
			padding: 0px 0px 0px 15px;
		}
	}
`;


interface ITabsComponentState {
    institutions: Institution[];
    programs: Program[];
	properties?:any;
    instId: string;
    programId: number;
}

export interface ITabsComponentProps {
	assignmentId:number;
    institutions: Institution[];
	programs: Program[];
    config: TestAssignmentFormConfig;
}

export class AssignmentTabsComponent extends React.Component<ITabsComponentProps, ITabsComponentState> {

    constructor(props: ITabsComponentProps) {
		super(props);

		// hold the topic in state for editing
		this.state = {
            institutions:this.props.institutions,
            programs:this.props.programs,
			properties:{},
            instId:"",
            programId:0
		};

	}

    handleOnchange = (name?:string, val?:any) => {
		this.setState(prevState => {
			let properties = {...prevState.properties}
			properties[name] = val
			return {properties}
		})
	}

    private async getTestAssignemnt() {
        const res : any = await ServiceRegistry.getQueryService().findOne(TestAssignment, {id:this.props.assignmentId});
        let data = res && res.data && res.data.entity || TestAssignment;
        this.setState({
            instId:data.institutionId,
            programId:data.programId,
            properties:{
				assignmentStatus:data.assignmentStatus,
				description:data.description,
				name:data.name,
				startDate:data.startDate,
				dueDate:data.dueDate
			}
        })
		
	}

    public async componentDidMount() {
		this.getTestAssignemnt();
	}

    public render() {

        const tabs: ITab[] = [];

        tabs.push({
            key: "assignment",
            label: <Label k="category.assignment" v="Assignment" />,
            content: (
                <Query.One
                    entity={TestAssignment}
                    args={{
                        id: this.props.assignmentId
                    }}
                >
                    {
                        (args) => {

                            if (args.loading) {
                                return <Loading />;
                            }

                            if (!args.data) {
                                return null;
                            }

                            return (
                                <React.Fragment>
                
                                <ContainerView key="assignForm" viewKey="assignForm">
                                    <CardView key="assignCard" viewKey="assignCard">
                                        <FragmentLayout
                                            fragments={displayFragments}
                                            layout= {this.props.config.userLayout}
                                            props={{
                                                onChange: this.handleOnchange,
                                                state: this.state,
                                                edit:true,
                                                assignmentId:this.props.assignmentId
                                            }}  
                                        />
                                    </CardView>
                                </ContainerView>
                            </React.Fragment>
                            );
                        }
                    }
                </Query.One>
            )
        });

        tabs.push({
            key: "questions",
            label: <Label k="category.questions" v="Questions" />,
            content: (
               
                <React.Fragment>
                    <QuizQuestionsComponent 
                        assignmentId={this.props.assignmentId}
                        status={iDef(this.state.properties["assignmentStatus"]) && this.state.properties["assignmentStatus"]}
                    />
                </React.Fragment>
                
            )
        });

        tabs.push({
            key: "enrollments",
            label: <Label k="category.enrollments" v="Enrollments" />,
            content: (
               
                    <React.Fragment>
                        <EnrollmentsComponent 
                            assignmentId={this.props.assignmentId}
                            status={iDef(this.state.properties["assignmentStatus"]) && this.state.properties["assignmentStatus"]}
                        />
                    </React.Fragment>
                
            )
        });

        return (
            <React.Fragment>
                <StyledDiv>
                    <TabsView viewKey="tabs" tabs={tabs} />
                </StyledDiv>
            </React.Fragment>
        )
    }
}


// WEBPACK FOOTER //
// ./src/panels/testAssignment/AssignmentTabsComponent.tsx